import React, {useRef} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";

import {LookRoomIdeasIcon} from "../../common/icons";
import COLOR_THEMES from "../../../colorThemes";
import {injectIntl} from "react-intl";
import {ROUTES} from "../../../routes";
import {setLookIntroStep, setLookOpened, setLookPageOpened} from "../../../actions/lookFunctions";
import IconButton from "@mui/material/IconButton";
import LookIntroPopper from "./lookIntro/lookIntroPopper";
import {LOOK_INTRO_STEPS, LOOK_INTRO_STEPS_MOBILE} from "../core/constants";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {getCommonVisualizerType} from "../../../config";
import {capitalizeFirstLetters} from "../../../misc/helpers";

export const getRoomIdeasTranslate = (intl, fabricatorData) => {
  if (!intl || !fabricatorData) {
    return ""
  }
  if (fabricatorData.isNhance) {
    return intl.formatMessage({id: "rooms." + capitalizeFirstLetters(getCommonVisualizerType())})
      + " " + intl.formatMessage({id: "tooltip.layouts"}) // Kitchen Layouts
  }
  return intl.formatMessage({id: "buttons.roomIdeas"});
}

const LookRoomIdeasButton = (props) => {

  const {activeTheme, setLookPageOpened, history, lookPageOpened, isMobile, intl, introStep, setLookIntroStep,
    lookOpened, setLookOpened, fabricatorData} = props;
  const anchorRef = useRef(null);

  const isActive = lookPageOpened === ROUTES.rooms;
  const popperStep = isMobile ? LOOK_INTRO_STEPS_MOBILE.rooms : LOOK_INTRO_STEPS.layoutsAndRooms;

  const roomIdeasButtonClick = () => {
    if (introStep === popperStep) {
      Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookRoomIdeasOnIntro);
      setLookIntroStep(introStep + 1);
      return false;
    }
    if (isActive) {
      Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookRoomIdeasClose);
      setLookPageOpened("");
      history.push(ROUTES.home);
    } else {
      Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookRoomIdeasOpen);
      setLookPageOpened(ROUTES.rooms);
      history.push(ROUTES.rooms);
    }
    if (lookOpened) {
      setLookOpened(null);
    }
  }

  const getIcon = (
    <SvgIcon>
      <LookRoomIdeasIcon color={COLOR_THEMES[activeTheme].primary} />
    </SvgIcon>
  )

  const buttonTranslate = getRoomIdeasTranslate(intl, fabricatorData);

  return (
    <div className={"look-room-button" + ((isActive || (introStep === popperStep)) ? " look-room-button--on-top" : "")}
         ref={anchorRef}>
      {isMobile ? (
        <IconButton aria-label={intl.formatMessage({id: "iconButton.rooms"})}
                    className={"look-icon" + (isActive && isMobile ? " look-icon--active" : " look-icon--white2")}
                    onClick={roomIdeasButtonClick}>
          {getIcon}
        </IconButton>
      ) : (
        <Button aria-label="Exit"
                style={fabricatorData.isNhance ? {padding: "0 24px"} : null}
                className={"look-button look-button--primary look-button--big" + (!isActive ? " look-button--white" : "")}
                startIcon={getIcon}
                onClick={roomIdeasButtonClick}>
          {buttonTranslate}
        </Button>
      )}
      <LookIntroPopper anchorRef={anchorRef}
                       currentStep={popperStep}
                       roomIdeasButtonTranslate={buttonTranslate}
                       toolTipText={`look.intro.step${popperStep}.rooms.tooltip`}
                       placement={isMobile ? "left" : "right"}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened, lookOpened, introStep} = store.lookState;
  const {activeTheme, isMobile} = store.serverState;
  const fabricatorData = store.fabricatorState;

  return {
    activeTheme,
    isMobile,
    lookPageOpened,
    lookOpened,
    introStep,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookOpened,
  setLookIntroStep,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookRoomIdeasButton)
  )
)
